<template>
  <div class="product_content">
    <div class='radius_bg' v-if="mod!=='Calendar'">
      <el-form class="form" :model='searchCondition' inline size='mini' @submit.native.prevent>
        <el-form-item label=''>
          <el-date-picker v-model='searchCondition.date_range' type='daterange' align='right' unlink-panels
                          range-separator='至' start-placeholder='开始日期' end-placeholder='结束日期'
                          value-format='yyyy-MM-dd'
                          style='width: 280px' :picker-options='pickerOptions'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label=''>
          <ProductLeaderSelect ref='refProductLeader' :leader-id.sync='searchCondition.leader_id'
                               @selected='selectedLeader' v-if="userPermissions.indexOf('product_view_all') > -1"/>
          <span v-else>{{ userInfo.nickname }} </span>
        </el-form-item>
        <el-form-item label=''>
          <CategoryCascader :identify='`product`' @cascaderChange='cascaderChange'/>
        </el-form-item>
        <el-form-item label=''>
          <el-input placeholder='商品名称' v-model='searchCondition.title' @change='handleQuery' clearable/>
        </el-form-item>
        <el-form-item label=''>
          <el-select @change='handleQuery' clearable v-model='searchCondition.unify' placeholder='是否统一机制'>
            <el-option label='是' value='1'></el-option>
            <el-option label='否' value='2'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=''>
          <template slot='label'>
            <el-link @click.stop.native='getBrand(true)' title='刷新可选品牌'><i
              :class='[loadingBrandStatus ? "el-icon-loading" : "el-icon-refresh"]'></i>
            </el-link>
          </template>
          <el-select clearable v-model='searchCondition.brand_id' filterable style='width: 100%' @focus='getBrand'
                     placeholder='请选择品牌'>
            <el-option v-for='item in brandOptions' :key='item.id' :label='item.name' :value='item.id'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=''>
          <el-input placeholder='可播平台' v-model='searchCondition.platform_name' @change='handleQuery' clearable/>
        </el-form-item>
        <el-form-item label=''>
          <el-select clearable v-model='searchCondition.online_cmn' filterable style='width: 100%' @change='handleQuery'
                     placeholder='请选择线上佣金'>
            <el-option v-for='(item, key) in onlineCmnOptions' :key='key' :label='item.name' :value='item.value'/>
          </el-select>
        </el-form-item>
        <el-form-item label=''>
          <el-select @change='handleQuery' clearable v-model='searchCondition.is_sec_kill' placeholder='是否秒杀品'>
            <el-option label='是' value='Y'/>
            <el-option label='否' value='N'/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="modePrice" style="width: 100px;margin-right: 2px" placeholder="" @change="handleQuery">
            <el-option key="price" label="日常价" value="price"></el-option>
            <el-option key="lb_price" label="直播价" value="lb_price"></el-option>
          </el-select>
          <el-input placeholder='最低价' class="w-100" v-model='price[0]' clearable/>
          ~
          <el-input placeholder='最高价' class="w-100" v-model='price[1]' clearable/>
        </el-form-item>
        <el-form-item label=''>
          <el-select @change='handleQuery' clearable v-model='searchCondition.used_season' placeholder='选择季节性' style='width: 110px'>
            <el-option label='春' value='春'></el-option>
            <el-option label='夏' value='夏'></el-option>
            <el-option label='秋' value='秋'></el-option>
            <el-option label='冬' value='冬'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=''>
          <el-input placeholder='产品产地' v-model='searchCondition.origin_place' @change='handleQuery' clearable/>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' icon='el-icon-search' @click='handleQuery'>搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 悬浮搜索按钮 -->
    <div v-else class="floating-search-btn" @click="searchDialogVisible = true">
      <el-button type="primary" circle size="medium" class="search-icon-btn">
        <i class="el-icon-search"></i>
      </el-button>
    </div>

    <init-loading :isInitLoading.sync='isInitLoading'></init-loading>

    <div class='radius_bg'>
      <div class='button-toolbar'>
        <el-row :gutter='10' class='button-row'>
          <el-col :span='1.5'>
            <el-button type='primary' icon='el-icon-plus' @click='handleAdd'
                       v-if="userPermissions.indexOf('product_create') > -1">添加
            </el-button>
          </el-col>
          <el-col :span='1.5'>
            <el-button v-if="userPermissions.indexOf('product_hand_over') > -1" type="warning" icon="el-icon-connection"
                       @click="toHandover">交接
            </el-button>
          </el-col>
          <el-col :span="1.5">
            <export-btn ref="refExportLinks" :class-name="`import-tpl-btn`" :can-export="true" key="refExportLinks"
                        @export="downLoadTemplate" lint-title="模板下载"/>
          </el-col>
          <el-col :span='1.5'>
            <product-case-import v-if='hasAuthority("product_import")' @success='handleQuery'/>
          </el-col>
          <el-col :span='1.5'>
            <export-btn type='primary' :plain='true' ref='refExportLink' lint-title="导出(含图)" key="refExportLink"
                        title='适合场景：数据量较小，比如小于1000条数据'
                        :can-export="userPermissions.indexOf('product_export') > -1"
                        @export='exportExcel'></export-btn>
          </el-col>
          <el-col :span='1.5'>
            <el-button icon='el-icon-download' @click='asyncExportExcel' type='warning' :plain='true'
                       title='适合场景：数据量较大,商品图片将被忽略'
                       v-if="userPermissions.indexOf('product_export') > -1" :loading='exportLoading'
                       :disabled='exportLoading'>
              导出表格
            </el-button>
          </el-col>
          <el-col v-if='userPermissions.indexOf("product_selection_done") > -1' :span='1.5'>
            <NewProduct></NewProduct>
          </el-col>
          <el-col :span='1.5'>
            <ProductSpecimen v-if='userPermissions.indexOf("product_specimen_manage") > -1'></ProductSpecimen>
          </el-col>
          <template v-if='mod === "Table"'>
            <el-col :span='1.5'>
              <ExportProductPpt v-if='userPermissions.indexOf("product_export") > -1'
                                :multiple-selection='multipleSelection'/>
            </el-col>
            <el-col :span='1.5' v-if='(userPermissions.indexOf("product_specimen_commit") > -1)'>
              <product-specimen-save :get-products='getSelectionProducts' />
            </el-col>
            <el-col :span='1.5' v-if='userPermissions.indexOf("product_transfer") > -1'>
              <el-popover
                placement="right"
                width="200"
                trigger="click">
                <div >
                  <product-transfer :c-type="2" :get-products='getSelectionProducts' @success='callbackProductTransfer' style='margin-bottom: 5px' />
                  <br/>
                  <product-transfer :c-type="3" :get-products='getSelectionProducts' @success='callbackProductTransfer' />
                </div>
                <el-button slot="reference" icon='el-icon-d-arrow-right'>转移</el-button>
              </el-popover>
            </el-col>
            <el-col :span='1.5' v-if='userPermissions.indexOf("product_transfer") > -1'>
              <el-popover
                placement="right"
                width="200"
                trigger="click">
                <div >
                  <product-copy :c-type="2" :get-products='getSelectionProducts' @success='callbackProductTransfer' style='margin-bottom: 5px' />
                  <br/>
                  <product-copy :c-type="3" :get-products='getSelectionProducts' @success='callbackProductTransfer' />
                </div>
                <el-button slot="reference" icon='el-icon-copy-document'>复制</el-button>
              </el-popover>
            </el-col>
          </template>
          <el-col :span='1.5'>
            <product-recycle v-if='userPermissions.indexOf("product_recycle_list") > -1' style='margin-right: 10px;'
                             @close='handleQuery'/>
          </el-col>
        </el-row>
        <div style='text-align: right'>
          <el-radio-group v-model='mod'>
            <el-radio-button label='Calendar'>卡片(新)</el-radio-button>
            <el-radio-button label='CalendarOld'>卡片(经典)</el-radio-button>
            <el-radio-button label='Table'>列表</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>

    <!-- 旧卡片-->
    <product-old-card v-if="mod==='CalendarOld'" :dataList='dataList' :loading='loading'
                      @handleCheck='handleCheck' @handleDetails='handleDetails'
                      @handleJoinLive='handleJoinLive' @handleEdit='handleEdit'></product-old-card>
    <!--表格-->
    <ProductTable
      :dataList="dataList"
      :mod="mod"
      :showPlatform="true"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
      @row-contextmenu="openMenu"
      @sort-change="changeTableSort"
      @edit="handleEdit"
      @delete="handleDelete"
    />

    <div style="display: flex;justify-content: space-between;align-items: center; background-color: #ffffff;">
      <div>
        <el-button :disabled="!multipleSelection.length" type='danger' @click='handleBatchDelete'
                   v-if="userPermissions.indexOf('product_delete_all') > -1 && mod === 'Table'">
          批量删除
        </el-button>
      </div>
      <pagination :hidden='total === 0' :background='true' v-if="mod !== 'Calendar'" :total.sync='total'
                  :page.sync='pageData.current_page' :autoScroll='true' :limit.sync='pageData.page_size'
                  :page-sizes="[12, 24, 36, 48]" @pagination='getList'/>
    </div>
    <!-- 新卡片 瀑布流-->
    <product-update-card ref="productUpdateCard" v-if="mod==='Calendar'" :searchCondition='searchCondition' :loading='loading'
                         @handleCheck='handleCheck' @handleDetails='handleDetails' :is-type="1"
                         @handleJoinLive='handleJoinLive' @handleEdit='handleEdit'></product-update-card>

    <!--    创建产品-->
    <ProductCreateEdit :visible.sync='open' :id='currId' :default-form-data='copyRow' />
    <!--    右键菜单-->
    <Contextmenu :id='currentId' :menu-data='menuData' :menuList='menuList' @change='handleCmd' />

    <ImportProductPanel :visible.sync='openImport' @close='handleQuery' />
    <!--   -PPT模式预览 -->
    <previewPPT :id='currId' :visible.sync='showPreview' fullscreen @close='getList'></previewPPT>
    <ProductLog :info-id='currId' :visible.sync='openLog' />
    <JoinLive :productId='productId' :visible.sync='showJoinlive'></JoinLive>
    <edit-specimen @submitData='handelStore' :visible.sync='dialogStore' :formStore.sync='formStore'></edit-specimen>
    <product-details :visible.sync='openDetails' :rowDetails='rowDetails' />


    <!-- 搜索弹窗 -->
    <ProductSearchDialog
      :visible.sync="searchDialogVisible"
      :search-condition="searchCondition"
      :mode-price="modePrice"
      :price="price"
      :identify="'product'"
      @confirm="handleSearchConfirm"
      @reset="handleSearchReset"
      @leader-selected="selectedLeader"
      @cascader-change="cascaderChange"
    />
  </div>
</template>

<script>
import ExportBtn from '@/components/export/ExportBtn'
import ProductCreateEdit from '@/pages/lb/product/ProductCreateEdit'
import CategoryCascader from '@/pages/category/components/CategoryCascader'
import {mapGetters} from 'vuex'
import Contextmenu from './Contextmenu'
import ImportProductPanel from '@/pages/lb/product/ImportProductPanel'
import ProductLog from '@/pages/lb/product/ProductLog'
import ProductLeaderSelect from '@/pages/lb/components/ProductLeaderSelect'
import ExportProductPpt from '@/pages/lb/components/ExportProductPpt'
import previewPPT from '@/pages/lb/product/PreviewPPT.vue'
import JoinLive from '@/pages/lb/product/JoinLive.vue'
import NewProduct from '@/pages/lb/product/NewProduct.vue'
import ProductSpecimen from '@/pages/lb/product/ProductSpecimen.vue'
import EditSpecimen from '@/pages/lb/product/EditSpecimen.vue'
import ProductSpecimenSave from '../components/ProductSpecimenSave.vue'
import ProductRecycle from './ProductRecycle.vue'
import ProductUpdateCard from './ProductListUpdated.vue'
import ProductOldCard from './ProductOldCard'

import ProductDetails from './ProductDetails'
import ProductTransfer from '@/pages/lb/product/component/transfer.vue'
import productCaseImport from './import.vue'
import ProductSearchDialog from './components/ProductSearchDialog.vue'
import ProductTable from './components/ProductTable.vue'
import ProductCopy from '@/pages/lb/product/component/copy.vue'

export default {
  name: 'ProductLibrary',
  components: {
    ProductCopy,
    ProductTransfer,
    ProductRecycle,
    ProductSpecimenSave,
    EditSpecimen,
    ExportProductPpt,
    ProductLeaderSelect,
    ProductLog,
    ImportProductPanel, Contextmenu, CategoryCascader, ProductCreateEdit, ExportBtn,
    JoinLive,
    NewProduct,
    ProductSpecimen,
    ProductDetails,
    previewPPT,
    ProductUpdateCard,
    ProductOldCard,
    productCaseImport,
    ProductSearchDialog,
    ProductTable

  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),
    currentId() {
      return this.currentRow ? this.currentRow.id : null
    }

  },
  provide() {
    return {
      joinType: 1
    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.getList()
        this.$nextTick(() => {
          this.$refs.productUpdateCard?.refreshList()
        })
      }
    }
  },
  data() {
    return {
      loadingBrandStatus: false,
      brandOptions: [],
      searchCondition: {
        leader_id: null,
        category_id: null,
        title: null,
        unify: null,
        date_range: [],
        platform_name: null,
        is_sec_kill: null,
        online_cmn: null,
        price: null,
        lb_price: null,
        origin_place: null
      },
      // 搜索弹窗相关
      searchDialogVisible: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      onlineCmnOptions: [
        // 线上佣金筛选项
        { value: '0~10', name: '0~10' },
        { value: '10~20', name: '10~20' },
        { value: '20~30', name: '20~30' },
        { value: '30~40', name: '30~40' },
        { value: '40~50', name: '40~50' },
        { value: '50~60', name: '50~60' },
        { value: '60以上', name: '60以上' }
      ],
      dataList: [],
      total: 0,
      orderSort: { id: 'desc' },
      pageData: { page_size: 12, current_page: 1 },
      loading: false,
      exportLoading: false,
      open: false,
      openLog: false,//日志模态框
      currId: null,
      copyRow: null,
      currentRow: {},
      menuData: {
        visible: false,
        top: 0,
        left: 0
      },
      //导入相关
      openImport: false,
      mod: 'Calendar',
      multipleSelection: [],
      showPreview: false,
      isInitLoading: true,
      showJoinlive: false,
      productId: '',
      menuList: {
        edit: true,
        log: true,
        del: true,
        copy: false
      },
      dialogStore: false,
      formStore: {
        nu: null,
        com: null,
        com_label: null,
        qty: 1,
        need_back: null,
        remark: null
      },
      popperVisible: false,
      openDetails: false,
      rowDetails: {},
      modePrice: 'price',
      price: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async downLoadTemplate() {
      //下载模板 downloadImportTpl
      try {
        const name = `产品导入模板`
        const response = await this.$api.downloadImportTpl({})

        this.$refs.refExportLinks.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }
      // this.$refs.refExportLinks.hideLoading()

    },
    handleCheck(val) {
      this.currId = val.id
      this.showPreview = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 级联菜单组件change事件
    cascaderChange(v) {
      this.searchCondition.category_id = null
      this.searchCondition.category_ids = null
      if (v.length) {
        this.searchCondition.category_id = v[(v.length - 1)]
        this.searchCondition.category_ids = v
      }
      this.handleQuery()
    },
    selectedLeader() {
      this.handleQuery()
    },
    async getList() {
      this.loading = true
      this.dataList = []
      const searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, this.pageData, { order: this.orderSort })
      const { list, pages } = await this.$api.getProductList(searchCondition)
      this.dataList = list || []
      this.pageData.current_page = pages.current_page || 1
      this.pageData.page_size = pages.page_size || 1
      this.total = pages.total
      this.loading = false
      this.isInitLoading = false
    },

    changeTableSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.handleQuery()
    },
    async getBrand(force) {
      this.loadingBrandStatus = true
      if (this.brandOptions.length === 0 || force) {
        // let data = await this.$api.selectCustomerBrands({ customer_id: this.formData.customer_id })
        const { options } = await this.$api.getBrandOptions()
        this.brandOptions = options
      }
      this.loadingBrandStatus = false
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
    },
    async asyncExportExcel() {
      this.exportLoading = true
      const searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, { order: this.orderSort })

      const { task_id } = await this.$api.asyncExportProduct(searchCondition)
      // this.$notify.warning(task_id)
      const msg = '<strong>点击这里 <a href=\'/download_file\' target=\'_blank\'>下载</a> 生成的文件:' + task_id + '</strong>'
      this.$notify({
        title: '导出文件生成中',
        dangerouslyUseHTMLString: true,
        message: msg,
        type: 'success',
        duration: 0
      })
      this.exportLoading = false
    },
    async exportExcel() {
      try {
        const searchCondition = this.handleSearchCondition()
        Object.assign(searchCondition, { order: this.orderSort })
        const name = `产品库`
        const response = await this.$api.exportProduct(searchCondition)
        this.$refs.refExportLink.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }
      this.$refs.refExportLink?.hideLoading()

    },
    handleSearchCondition() {
      const cond = {}
      // if (this.searchCondition.category_id) {
      //   cond['category_id'] = this.searchCondition.category_id
      // }
      if (this.searchCondition.category_ids) {
        cond['category_ids'] = this.searchCondition.category_ids
      }
      if (this.searchCondition.title) {
        cond.title = this.searchCondition.title
      }
      if (this.searchCondition.leader_id) {
        cond['leader_id'] = this.searchCondition.leader_id
      }
      if (this.searchCondition.brand_id) {
        cond['brand_id'] = this.searchCondition.brand_id
      }
      if (this.searchCondition.unify) {
        cond['unify'] = this.searchCondition.unify
      }
      if (this.searchCondition.date_range) {
        cond['date_range'] = this.searchCondition.date_range
      }
      if (this.searchCondition.platform_name) {
        cond['platform_name'] = this.searchCondition.platform_name
      }
      if (this.userPermissions.indexOf('product_view_all') === -1) {
        cond['leader_id'] = this.userInfo.id
      }
      if (this.searchCondition.is_sec_kill) {
        cond['is_sec_kill'] = this.searchCondition.is_sec_kill
      }
      if (this.searchCondition.used_season) {
        cond['used_season'] = this.searchCondition.used_season
      }
      if (this.searchCondition.origin_place) {
        cond['origin_place'] = this.searchCondition.origin_place
      }
      // 线上佣金
      cond['online_cmn'] = this.searchCondition.online_cmn || null

      cond[this.modePrice] = this.price.map(v => (v != null && v !== '' ? Number(v) : 0))
      // platform_name
      return cond
    },
    handleEdit(row) {
      this.copyRow = {}
      this.currId = row.id
      this.open = true
    },
    showLog(row) {
      this.copyRow = {}
      this.currId = row.id
      this.openLog = true
    },
    handleCopy(row) {
      // let ids = row.category_ids.replace(/\[|]/g, '').split(',')
      this.copyRow = Object.assign({}, row)
      delete this.copyRow.leader_id
      delete this.copyRow.leader_name
      delete this.copyRow.id
      delete this.copyRow.created_at
      delete this.copyRow.updated_at

      this.currId = null
      this.open = true
    },
    handleAdd() {
      this.currId = null
      this.copyRow = {}
      this.open = true
    },
    async delInfo(id) {
      try {
        const info = await this.$api.delProduct(id)
        if (info) {
          await this.getList()
          this.msgSuccess('删除成功')
        }
      } catch {
        this.$message.error('删除失败')
      }
    },
    handleDelete(row) {
      const id = row.id
      this.$confirm(`是否确认删除产品【${row.title}/${row.category}/${row.spec_name}】?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delInfo(id)
      }).catch(() => {
        this.msgWarn('取消操作')
      })
    },
    handleBatchDelete: function () {
      const ids = this.multipleSelection.map(_ => {
        return _.id
      })
      if (!ids.length) {
        return this.$message.warning('请选择要删除的产品')
      }

      this.$confirm(`已选中${ids.length}个产品，确认删除吗？`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$api.delProduct(ids)
        await this.getList()
        this.msgSuccess('删除成功')
      })
    },
    //右键菜单关闭
    closeMenu(e) {
      //未点击在 菜单上，则关闭
      if (e.target.className.indexOf('contextmenu__item') === -1) {
        this.menuData.visible = false
        document.removeEventListener('click', this.closeMenu)
      }
    },
    // eslint-disable-next-line no-unused-vars
    openMenu(row, column, e) {
      this.currentRow = row
      // this.$notify.info(`右键菜单:${e.clientY}`)
      e.preventDefault()//阻止元素发生默认的行为
      // const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      // const offsetTop = 0// this.$el.getBoundingClientRect().top; // container margin top

      this.menuData = {
        visible: true,
        left: e.pageX,//- offsetLeft
        top: e.pageY// - offsetTop
      }
      document.addEventListener('click', this.closeMenu) // 给整个document新增监听鼠标事件，点击任何位置执行foo方法
    },
    handleCmd(cmd) {
      switch (cmd) {
        case '1':
          this.handleEdit(this.currentRow)
          break
        case '2':
          this.handleCopy(this.currentRow)
          break
        case '3':
          this.handleDelete(this.currentRow)
          break
        case 'log':
          this.showLog(this.currentRow)
          break
      }
    },
    handleJoinLive(row) {
      this.showJoinlive = true
      this.productId = row.id
    },
    async handelStore() {
      const { nu, com, qty, need_back, remark, com_label } = this.formStore
      const items = this.multipleSelection.map((i) => {
        return {
          product_id: i.id,
          qty: qty,
          need_back: need_back
        }
      })
      const data = {
        nu: nu,
        com: com,
        com_label: com_label,
        remark: remark,
        items: items
      }
      try {
        const id = await this.$api.addLbProductSpecimenCommit(data)
        if (id) {
          this.$message.success('新增成功！')
          this.dialogStore = false
        } else {
          this.$message.error('未知错误,请联系管理员')
        }
      } catch {
        this.$message.error('保存失败')
      }
    },
    getSelectionProducts: function () {
      return this.multipleSelection || []
    },
    handleDetails(row) {
      this.rowDetails = row
      this.openDetails = true
    },
    callbackProductTransfer: function () {
      this.$refs.multipleTable.clearSelection()
      this.handleQuery()
    },
    toHandover: function () {
      const routeUrl = this.$router.resolve({
        name: 'productHandover',
        query: {type: 'product'}
      })
      window.open(routeUrl.href, '_blank')
    },
    // 搜索确认
    handleSearchConfirm() {
      this.searchDialogVisible = false
      this.handleQuery()
    },
    // 搜索重置
    handleSearchReset() {
      this.searchCondition = {
        leader_id: null,
        category_id: null,
        title: null,
        unify: null,
        date_range: [],
        platform_name: null,
        is_sec_kill: null,
        online_cmn: null,
        price: null,
        lb_price: null,
        origin_place: null
      }
      this.modePrice = 'price'
      this.price = []
      // 重置级联选择器
      if (this.$refs.refProductLeader) {
        this.$refs.refProductLeader.clear()
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeMenu)
  },
  mounted() {
    if (this.mod !== 'Calendar') {
      this.handleQuery()
    }
  }
}
</script>

<style lang='scss' scoped>
@import "../style/main.scss";


.product_content {
  height: 100%;
  .radius_bg {
    margin: 0;
    padding: 0;
  }

  .button-toolbar {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
    row-gap: 15px;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .button-row {
    display: flex;
    flex-wrap: wrap;
    row-gap: 15px;
  }

  ::v-deep .image-slot {
    margin: 0 auto;
  }
}

/* 悬浮搜索按钮样式 */
.floating-search-btn {
  position: fixed;
  right: 40px;
  bottom: 120px;
  z-index: 999;
  .search-icon-btn {
    width: 50px;
    height: 50px;
    font-size: 24px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    opacity: 0.6;


    &:hover {
      opacity: 1 !important;
      transform: scale(1.1);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    }
  }
  ::v-deep .el-button--primary{
    background-color: #ff3176;
  }
}
</style>
<style>
.popperClass {
  max-height: 800px;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
